var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { busService } from "../bus";
import { MulticastDelegate, RoomChangedMessage, LoadRoomMessage, EnterRoomMessage, AskOkMessage, ROOT_MODEL_UID, CurrentSubRoomsRequestMessage, ExitCurrentRoomMessage, CurrentSubRoomsResponseMessage, RoomLoadedStateMessage, RoomLoadedState, RequestRoomLoadedStateMessage } from "flavr-common";
import { modelPool } from "@modules/model";
class RoomService {
    constructor() {
        this.connection = busService.connection("RoomService");
        this._currentRoomModelUID = ROOT_MODEL_UID;
        this.onRoomChangedDelegate = new MulticastDelegate();
        this.handleRoomChangedMessage = (msg) => {
            if (this._currentRoomModelUID === msg.uid)
                return;
            const newRoomModel = modelPool.getModel(msg.uid);
            if (newRoomModel === undefined)
                return;
            this._currentRoomModelUID = newRoomModel.getUID();
            this.onRoomChangedDelegate.invoke();
        };
        this.connection.subscribeByType(RoomChangedMessage, this.handleRoomChangedMessage);
    }
    get currentRoomModelUID() {
        return this._currentRoomModelUID;
    }
    getSubRoomsOfCurrentRoom() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.connection.waitForConnectionReady();
                const currentSubRoomsResponseMessage = yield this.connection.askByMessageType(new CurrentSubRoomsRequestMessage(), CurrentSubRoomsResponseMessage);
                const modelUIDs = [];
                if (currentSubRoomsResponseMessage.availableRooms.length > 0) {
                    for (const roomUid of currentSubRoomsResponseMessage.availableRooms) {
                        const model = modelPool.getModel(roomUid);
                        if (model !== undefined) {
                            modelUIDs.push(model.getUID());
                        }
                    }
                }
                return modelUIDs;
            }
            catch (error) {
                console.error("[room]", error);
            }
            return undefined;
        });
    }
    loadAndEnterSubRoom(roomUid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.connection.askByMessageType(new RequestRoomLoadedStateMessage(roomUid), RoomLoadedStateMessage).then((msg) => __awaiter(this, void 0, void 0, function* () {
                    switch (msg.state) {
                        case RoomLoadedState.Loaded:
                            // the room has been loaded so we can enter
                            this.connection.send(new EnterRoomMessage(roomUid));
                            break;
                        case RoomLoadedState.Loading:
                        case RoomLoadedState.Planned:
                            break;
                        case RoomLoadedState.NotLoaded: {
                            // loading the room has not yet started.
                            // (should only happen if autoload == false)
                            const askOkMessage = yield this.connection.askByMessageType(new LoadRoomMessage(roomUid, undefined, true), AskOkMessage);
                            if (askOkMessage.type === "AskOkMessage") {
                                this.connection.send(new EnterRoomMessage(roomUid));
                            }
                            break;
                        }
                    }
                }));
            }
            catch (error) {
                console.error("[room]", error);
            }
        });
    }
    exitCurrentRoom() {
        const currentRoom = modelPool.getRoomOrThrow(this._currentRoomModelUID);
        if (currentRoom.getRoomDepth() === 0)
            return;
        this.connection.send(new ExitCurrentRoomMessage());
    }
}
export const roomService = new RoomService();
